import { render, staticRenderFns } from "./UpdateAlbum.vue?vue&type=template&id=d6ccaf32&scoped=true&"
import script from "./UpdateAlbum.vue?vue&type=script&lang=js&"
export * from "./UpdateAlbum.vue?vue&type=script&lang=js&"
import style0 from "./UpdateAlbum.vue?vue&type=style&index=0&id=d6ccaf32&scoped=true&lang=scss&"
import style1 from "./UpdateAlbum.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6ccaf32",
  null
  
)

export default component.exports